import { axiosObject } from "../config";

export default function deletePYPDataByUuid(id: any) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/posted_properties/_delete";
    let payload = {
      filterBy: [
        {
          attribute: "uuid",
          op: "eq",
          value: id,
        },
      ],
    };
    console.log("idd", id);

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
